import { SidePanelName } from '@features/ui-layout/components/SidePanel/SidePanelFactory';
import { NextRouter } from 'next/router';
import { UrlObject } from 'url';

export const routePath = {
  home: '/',
  account: '/account',
  login: '/login',
  register: '/register',
  profile: '/profile',
  articles: '/articles',
  quiz: '/quiz',
  error: '/error',
  conditions: '/conditions',
};

/**
 * Query params for side panel
 */
interface SidePanelRouterQuery {
  sidePanel: string;
  sidePanelId?: string;
  sidePanelParamOne?: string;
}

interface RouteProps {
  pathname: string;
}
const getRoute = {
  account: (): RouteProps => ({ pathname: routePath.account }),
  home: (): RouteProps => ({ pathname: routePath.home }),
  login: (): RouteProps => ({ pathname: routePath.login }),
  register: (): RouteProps => ({ pathname: routePath.register }),
  profile: (): RouteProps => ({ pathname: routePath.profile }),
  articles: (): RouteProps => ({ pathname: routePath.articles }),
  article: (slug: string): RouteProps => ({ pathname: `${routePath.articles}/${slug}` }),
  quiz: (key: string): RouteProps => ({ pathname: `${routePath.quiz}/${key}` }),
  results: (key: string): RouteProps => ({ pathname: `${routePath.quiz}/${key}/results` }),
  articlesDyn: (): RouteProps => ({ pathname: `${routePath.articles}/[id]` }),
  error: (): RouteProps => ({ pathname: routePath.error }),
  conditions: (): RouteProps => ({ pathname: routePath.conditions }),
  openSidePanelEntity: (
    router: NextRouter,
    panel: SidePanelName,
    sidePanelId?: string | number,
    sidePanelParamOne?: string | number,
  ): UrlObject => ({
    pathname: router.pathname,
    query: {
      ...router.query,
      ['sidePanel' satisfies keyof SidePanelRouterQuery]: panel,
      ...(sidePanelId ? { sidePanelId } : {}),
      ...(sidePanelParamOne ? { sidePanelParamOne } : {}),
    },
  }),
  closeSidePanel: (router: NextRouter): UrlObject =>
    clearUrlFromExtraQueryParams(
      {
        pathname: router.pathname,
        query: router.query,
      },
      ['sidePanel', 'sidePanelId', 'sidePanelParamOne'] satisfies Array<keyof SidePanelRouterQuery>,
    ),
};

export default getRoute;

function clearUrlFromExtraQueryParams(queryAndPath: UrlObject, toDelete: Array<string>): UrlObject {
  const newQueryAndPath = queryAndPath;
  toDelete.forEach(key => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete newQueryAndPath.query[key];
  });

  return newQueryAndPath;
}
